import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { BellSimpleIcon } from '@/components/icons';
import { useNotificationCount } from '@/lib/hooks/useNotifications';

interface NotificationBellProps {
  /** Click handler */
  onClick?: () => void;
  /** Additional CSS classes */
  className?: string;
  /** Button variant */
  variant?: 'default' | 'ghost' | 'outline';
  /** Size variant */
  size?: 'default' | 'sm' | 'lg' | 'icon';
  /** Smaller icon */
  small?: boolean;
}

export function NotificationBell({
  onClick,
  className,
  variant = 'ghost',
  size = 'lg',
}: NotificationBellProps) {
  // Fetch notification count directly and refresh every 1 minute (60,000 ms)
  const { unread } = useNotificationCount({ refreshInterval: 60000 });

  return (
    <div className="pr-1">
      <Button
        variant={variant}
        size={size}
        type="button"
        onClick={onClick}
        aria-label={
          unread > 0 ? `${unread} unread notification${unread > 1 ? 's' : ''}` : 'Notifications'
        }
        className={cn(
          'relative inline-flex items-center justify-center rounded-full p-2 text-primary-800 transition-colors hover:text-primary-900',
          '[&_svg]:!h-6 [&_svg]:!w-6',
          className
        )}
      >
        <BellSimpleIcon size={24} strokeWidth={1.75} className="shrink-0 h-6 w-6 text-current" />

        <span className="absolute right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full !bg-aered-600 px-1 text-[11px] font-semibold leading-none text-white">
          {unread > 99 ? '99+' : unread}
        </span>
      </Button>
    </div>
  );
}
